// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4933":"01560d98","8975":"74779b01"}[chunkId] + ".chunk.css";
};